import PropTypes from 'prop-types';
import {connect} from 'react-redux';

function Link(props) {
  const linkContent = props.lang[props.content];
  let textBefore = '';
  let textAfter = '';
  if (props.surroundingText) {
    const surroundingText = props.lang[props.surroundingText];
    const partsOfSurroundingText = surroundingText.split('{0}');
    textBefore = partsOfSurroundingText[0] || '';
    textAfter = partsOfSurroundingText[1] || '';
  }
  return (
    <p className="addressField_link">
      {textBefore}
      <a href={props.href} target="_blank">{linkContent}</a>
      {textAfter}
    </p>
  );
}

Link.propTypes = {
  lang: PropTypes.object.isRequired,
  href: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  surroundingText: PropTypes.string,
};

const mapStateToProps = state => ({
  lang: state.lang,
});

export default connect(
  mapStateToProps,
)(Link);
